import { useState, useEffect } from "react";

import shopify from "./shopify";

let cart = {
  items: [],
  item_count: 0,
};

let listeners = [];
let hampers = []

const notifyListeners = () => {
  listeners.forEach((listener) => listener(cart));
};

export async function fetchCart() {
  const response = await fetch(`/cart.js`);
  cart = await response.json();
  hampers = await shopify.getProductHampers(cart.items);
  notifyListeners();
}

const requestCart = async (url, payload, action, fetchUpdatedCart = true) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return { success: false, error: errorData?.message || `Failed to ${action}` };
    }

    if (fetchUpdatedCart) fetchCart();

    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const addToCart = async (payload, fetchUpdatedCart = true) => {
 return await requestCart("/cart/add.js", payload, "add item", fetchUpdatedCart);
};

export const updateItem = async (payload, fetchUpdatedCart = true) => {
  return await requestCart(
    "/cart/change.js",
    payload,
    "update item",
    fetchUpdatedCart,
  );
};

export const updateItems = async (payload, fetchUpdatedCart = true) => {
  return await requestCart(
    "/cart/update.js",
    payload,
    "update items",
    fetchUpdatedCart,
  );
};

export const useCart = (isMainCart) => {
  const [currentCart, setCurrentCart] = useState(cart);

  useEffect(() => {
    listeners.push(setCurrentCart);
    if (isMainCart) fetchCart();

    return () => {
      listeners = listeners.filter((listener) => listener !== setCurrentCart);
    };
  }, []);

  return {
    cart: currentCart,
    hampers
  };
};
